module.exports = "https://web-assets.ifttt.com/packs/media/connect/right_triangle-0d784b3b.svg";